import * as api from '../../../apis/units'
import { createSelector } from 'reselect'

const FETCH_UNITS_REQUESTED = 'FETCH_UNITS_REQUESTED'
const FETCH_UNITS_SUCCESS = 'FETCH_UNITS_SUCCESS'
const FETCH_UNITS_FAILED = 'FETCH_UNITS_FAILED'

export const fetchUnits = () => (dispatch) => {
	dispatch({ type: FETCH_UNITS_REQUESTED, data: {} })
	api.search().then((response) => {
		if (response && response.isSuccessful) {
			return dispatch({ type: FETCH_UNITS_SUCCESS, data: response.units })
		} else if(!response || !response.redirectTo) {
			return dispatch({ type: FETCH_UNITS_FAILED, data: {} })
		}
	})
	return
}

const initial = {
	units: [],
	searchUnits: [],
	sortField: 'modifiedDateSeconds',
	isDescending: true,
	filter: 0
}

export const reducer = (state = initial, action) => {
	switch (action.type) {
		case FETCH_UNITS_SUCCESS:
			return { ...state, units: action.data }
		case 'SIGN_OUT_REQUESTED':
			return initial
		default:
			return { ...state }
	}
}

const mainSelector = (state) => state.units

export const searchUnitsSelector = createSelector(mainSelector, (state) => {
	return state.searchUnits
})

export const hasUnitsSelector = createSelector(mainSelector, (state) => {
	return state.units && state.units.length > 0
})

export const unitsSelector = createSelector(mainSelector, (state) => {
	return state.units
})

export const unitSuffixSelector = createSelector(mainSelector, unitsSelector, (state, units) => (id) => {
	if (units && units.length > 0) {
		let x = units.find((r) => r.id === id)

		if (x) return x.suffix
	}
	return null
})

export const unitNameSelector = createSelector(mainSelector, unitsSelector, (state, units) => (id) => {
	if (units && units.length > 0) {
		let x = units.find((r) => r.id === id)

		if (x) return x.name
	}
	return null
})

export const sortUnitsDirectionSelector = createSelector(mainSelector, (state) => {
	return state.isDescending
})

export const sortUnitsFieldSelector = createSelector(mainSelector, (state) => {
	return state.sortField
})
